export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: '¿Funciona para todas las edades?',
    answer:
      'Sí. El MEGAPACK tiene sesiones para Primaria (1º a 6º) y Secundaria (1º a 3º). Cada volumen está dividido por niveles de progresión motriz, no por edad, así que adaptás según tu grupo real.',
  },
  {
    question: '¿Es 100% PDF?',
    answer:
      'Sí, todo imprimible. Lo descargás en la computadora, la tablet o el celular y lo usás sin internet (recomendamos descargarlo una vez). El acceso es de por vida.',
  },
  {
    question: '¿Cuánto tiempo toma implementarlo?',
    answer:
      'Está listo para usar desde el día 1. Literal: abrís el volumen, copiás una sesión, entrás al patio y enseñás. No hay curva de aprendizaje.',
  },
  {
    question: '¿Sirve si enseño en una escuela pública sin presupuesto?',
    answer:
      'Perfectamente. El 40% de nuestros usuarios están en escuelas públicas de Latinoamérica sin presupuesto. Hay un volumen entero de juegos sin material: está diseñado para esa realidad.',
  },
  {
    question: '¿Puedo usar el material este año si es 2026?',
    answer:
      'Sí. Las bases pedagógicas no cambian de un año a otro y las sesiones están diseñadas para durar. Además, el Planificador Anual se adapta a cualquier ciclo lectivo.',
  },
  {
    question: '¿Qué pasa si no me gusta?',
    answer:
      'Reembolso total en 7 días, sin preguntas. Igual te lo decimos: la tasa de devolución es del 0,2% porque el sistema funciona.',
  },
  {
    question: '¿Hay actualizaciones o soporte?',
    answer:
      'Acceso de por vida a todo lo que agreguemos. Además entrás a un grupo exclusivo de docentes en WhatsApp/Telegram donde compartimos recursos, dudas y mejoras.',
  },
]
